import React from 'react';
import propTypes from 'prop-types';
import { TextField } from 'formik-material-ui';
import { Field } from 'formik';
import * as Yup from 'yup';

export const type = "text";
export const label = "Name";
export const defaultValue = "x";

export const schema = Yup.string().required('Required');

export default function ExpressionName({ namespace, className, isSubmitting, ...props }) {

  return (
    <Field
      size='small'
      className={className}
      label={label}
      placeholder={label}
      component={TextField}
      name={namespace}
      type={type}
      disabled={isSubmitting}
      onClick={(ev) => ev.stopPropagation()}
    />
  );
}

ExpressionName.propTypes = {
  namespace: propTypes.string,
  className: propTypes.string,
  isSubmitting: propTypes.bool,
}
